<template>
    <div class="ml-auto mr-auto sm:mr-0 mb-5 w-full flex justify-end p-4 bg-white rounded flex-col md:flex-row">
        <div class="w-full md:w-1/2 flex justify-center items-center mb-5 md:mb-0">
            <div class="flex justify-center items-center">
                <span class="text-base mr-3">{{ $__('opportunities.total_suggested') }}:</span>
                <span class="text-3xl font-light w-24">{{ this.opportunities.length }}</span>
            </div>
        </div>
        <div class="w-full md:w-1/2">
            <BarChart :data="getTransformedOpportunitiesChartData()"/>
        </div>
    </div>
</template>

<script>
import BarChart from "@/Components/Charts/Bar";
import _ from "lodash";

export default {
    data: () => ({
        opportunities: [],
    }),
    components: {
        BarChart,
    },
    methods: {
        getTransformedOpportunitiesChartData() {
            const dataSetColors = this.statuses.map(status => {
                return this.getColorByOpportunityStatus(status);
            });

            const dataSetItems = this.statuses.map(status => {
                return this.opportunities.filter(opportunity => opportunity.status === _.toLower(status)).length;
            });

            return {
                labels: this.statuses,
                datasets: [{
                    backgroundColor: dataSetColors,
                    data: dataSetItems,
                }]
            }
        },
        getColorByOpportunityStatus(status) {
            switch (status) {
                case 'Open':
                    return 'rgb(17 87 195)';
                case 'Won':
                    return 'rgb(58 167 0)';
                case 'Lost':
                    return '#EF4444';
                default:
                    return 'rgb(17 87 195)';
            }
        },
    },
    created() {
        this.opportunities = this.$page.props.allOpportunities;
        this.statuses = [...new Set(this.opportunities.map(({status}) => _.capitalize(status)))];
    }
}
</script>
